import React, { CSSProperties } from 'react';
import { ImageSvg } from '../utils/customIcon';

interface Props {
	containerClass?: String;
	imgClass?: String;
	containerCss?: CSSProperties;
	imgCss?: CSSProperties;
}

export const Research = (props: Props) => {
	const svg = require('./research.svg');
	return <ImageSvg {...props} svg={svg} />;
};

export const ResearchV2 = (props: Props) => {
	const svg = require('./research-v2.svg');
	return <ImageSvg {...props} svg={svg} />;
};

